import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, IndianRupee } from "lucide-react";
import { fetchSevas } from "@/api/sevas";
import { useLang } from "@/i18n";
import PageHeader from "@/components/PageHeader";

export default function Sevas() {
  const [sevas, setSevas] = useState([]);
  const [cat, setCat] = useState("All");
  const categoriesRef = useRef(null);
  const { t } = useLang();

  useEffect(() => { fetchSevas().then(setSevas).catch(() => {}); }, []);

  useEffect(() => {
    const scrollFrame = requestAnimationFrame(() => {
      categoriesRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    return () => cancelAnimationFrame(scrollFrame);
  }, []);

  const categories = useMemo(() => {
    const seen = new Map();
    sevas.forEach(s => { if (!seen.has(s.category)) seen.set(s.category, s); });
    return [{ key: "All" }, ...Array.from(seen.entries()).map(([key, s]) => ({ key, item: s }))];
  }, [sevas]);

  const filtered = cat === "All" ? sevas : sevas.filter(s => s.category === cat);

  return (
    <div data-testid="sevas-page"  ref={categoriesRef}>
      <PageHeader eyebrow={t.sevas.eyebrow} title={t.sevas.title} sub={t.sevas.sub} />

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div
            className="flex flex-wrap justify-center gap-2 mb-12 scroll-mt-36 lg:scroll-mt-40"
            data-testid="sevas-filter"
          >
            {categories.map(c => (
              <button
                key={c.key}
                data-testid={`seva-cat-${c.key.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setCat(c.key)}
                className={`px-5 py-2 rounded-full text-[13px] font-medium transition-colors ${
                  cat === c.key ? "bg-[#7B1818] text-[#FDFBF7]" : "bg-white text-[#2A2118] border border-[#E5DAC7] hover:bg-[#F4EBDB]"
                }`}
              >
                {c.key === "All" ? t.common.all : c.key}
              </button>
            ))}
          </div> */}

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((s, i) => (
              <article key={s.id} data-testid={`seva-card-${i}`} className="card-soft reveal p-7 flex flex-col">
                {/* <div className="eyebrow">{s.category}</div> */}
                <h3 className="mt-3 font-display text-2xl text-[#2A2118] leading-snug">{s.name}</h3>
                <p className="mt-3 text-[14px] text-[#5C4D42] leading-relaxed flex-1">{s.description}</p>

                <div className="mt-6 flex items-center justify-between border-t border-[#E5DAC7] pt-5">
                  <div className="flex items-baseline gap-1">
                    <IndianRupee size={16} className="text-[#7B1818]" />
                    <span className="font-display text-3xl text-[#7B1818]">{s.amount.toLocaleString("en-IN")}</span>
                  </div>
                  <Link
                    to={`/sevas/book/${s.id}`}
                    data-testid={`seva-book-btn-${i}`}
                    className="btn-primary text-[13px]"
                  >
                    {t.common.bookNow} <ArrowRight size={14} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
